'use strict';

import angular from 'angular';

export class ModuleComponent {

  /*@ngInject*/
  constructor($scope, Storage, WindowService, $q) {
    this.Storage = Storage;
    this.scope   = $scope;
    this.Promise = $q.defer;

    this.closeWindow = WindowService.delItem;
  }

  $onInit() {
    this.module = this.data.module || {};
  }

  save() {
    return this.Storage.saveModule(this.module)
      .then(() => this.close())
      .catch(err => console.error(err));
  }

  close() {
    this.closeWindow(this.data.id);
  }
}



export default angular.module('storageApp.module', [])
  .component('module', {
    bindings: {data: '='},
    transclude: true,
    template: require('./module.html'),
    controller: ModuleComponent,
    controllerAs: 'moduleCtrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/module/module.component.js